import { render, staticRenderFns } from "./CustomOrderList.vue?vue&type=template&id=1e3e7176&"
import script from "./CustomOrderList.vue?vue&type=script&lang=js&"
export * from "./CustomOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports